import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'

export interface AboutCourseSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const AboutCourseSection = (props: AboutCourseSectionProps) => {
  const { className = '', ...rest } = props
  const secondRow = [
    {
      id: 1,
      header: 'Актуальные учебные программы',
      text: 'На курсе рассматриваются современные и востребованные среди клиентов методы психологического консультирования (Гештальт, КПТ, ОКРТ и др Мы регулярно отслеживаем запрос клиентов и предложения профессиональных психологов и обновляем учебные программы.'
    },
    {
      id: 2,
      header: 'Много практики',
      text: 'Вас ждёт от 500 ак. часа практики в разных форматах: интерактивный тренажёр, работа в тройках, практические занятия с преподавателем, супервизия и анализ демосессий. Преподаватели помогут вам начать практику в безопасной, поддерживающей атмосфере.'
    }
  ]
  return (
    <section className={cn('container container-slim', className)}>
      <h2 className='typo-section-heading typo-section-heading-mb'>
        Об обучении
      </h2>
      <div className='grid grid-cols-[2fr_1.4fr_0.6fr] h-[300px] gap-[16px]'>
        <div className='bg-[#977EE93B] h-full p-[24px] rounded-[16px]'></div>
        <div className='bg-[#7D5EE4] h-full p-[24px] rounded-[16px] text-white flex flex-col justify-between'>
          <p className='text-[64px]'>500 часов</p>
          <p>практики в разных форматах</p>
        </div>
        <div className='bg-[#1D1D1D]  h-full p-[24px] rounded-[16px] text-white flex flex-col justify-between'>
          <p className='text-[64px]'>70%</p>
          <p>занятий практические</p>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-[16px] mt-[16px]'>
        {secondRow.map(el => (
          <div className='bg-[#F2F2F2] rounded-[24px] p-[24px]' key={el.id}>
            <p className='text-[24px] font-medium mb-[16px]'>{el.header}</p>
            <p className='max-w-[500px]'>{el.text}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
